<template>
  <header class="site-header flex justify-content-between">
    <!--    <userNotifications :notifications="notifications"/>-->
    <div class="flex">
      <a @click="mixinGoToRouter('home')" href="#" class="nav-toggle">
        <div class="hamburger hamburger--arrowturn">
          <div class="hamburger-box text-center">
            <i class="icon-fa icon-fa-home fs-22"/>
          </div>
        </div>
      </a>
      <a href="#" class="nav-toggle" @click="onNavToggle">
        <div class="hamburger hamburger--arrowturn">
          <div class="hamburger-box">
            <div class="hamburger-inner"/>
          </div>
        </div>
      </a>
    </div>
    <div>
      <div class="search_panel">
        <input
          @keyup="search"
          @blur="search"
          type="search"
          placeholder="Поиск по меню..."
          class="form-control"
        />
      </div>

      <div class="action-list flex">
        <div
          class="d-none d-lg-block"
          v-if="isAllowToShow('noSMSUpdate')"
          style="padding-right: 10px"
        >
          <p class="badge badge-danger">новые SMS не поступают!</p>
        </div>
        <div class="mr-4 ml-2">
          <!--            <WorkShift/>-->
          <SelectWorkShift v-if="$currentUserRoles && ($currentUserRoles.includes('manager') ||
            $currentUserRoles.includes('managerAssist'))"/>
        </div>
        <div class="login-data d-none d-lg-block">
          <strong>{{ $currentUser && $currentUser.nick_name }}</strong>
          <p>{{ $currentUser.login }}</p>
        </div>
        <div
          class="p-l-10"
          v-if="$currentUserRoles && (
          $currentUserRoles.includes('manager') ||
            $currentUserRoles.includes('managerAssist')
        )"
        >
          <a href="#" @click="callToNumber">
            <i class="icon-fa icon-fa-phone-square"></i>
          </a>
        </div>
        <NotificationList/>
        <ul class="action-list">
          <li>
            <v-dropdown :show-arrow="false">
              <a
                slot="activator"
                href="#"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                class="avatar"
              >
                <img src="/assets/img/avatars/avatar.png" alt="Avatar"/>
              </a>
              <v-dropdown-item>
                <span class="manager_name">{{ $currentUser && $currentUser.name }}</span>
                <a href="#" @click.prevent="openUserSettings">
                  <i class="icon-fa icon-fa-cogs"/> Настройки
                </a>
              </v-dropdown-item>
              <v-dropdown-item>
                <a href="#" class="dropdown-item" @click.prevent="logout">
                  <i class="icon-fa icon-fa-sign-out"/> Выход
                </a>
              </v-dropdown-item>
            </v-dropdown>
          </li>
        </ul>
      </div>
      <ModalPhoneCallByNumber
        v-if="openModalPhoneCall"
        :closeModal="() => (openModalPhoneCall = false)"
      />
    </div>
  </header>
</template>
<script type="text/babel">
import Auth from "../../../services/auth";
// import userNotifications from "../../../components/notifications/userNotifications";
import ModalPhoneCallByNumber from "@/components/phoneCalls/ModalPhoneCallByNumber.vue";
import WorkShift from "@/components/users/WorkShift";
import NotificationList from '@/components/notifications/NotificationList'
import SelectWorkShift from "@/components/users/SelectWorkShift.vue";

export default {
  props: ["searchByMenu"],
  components: {
    SelectWorkShift,
    // userNotifications,
    WorkShift,
    ModalPhoneCallByNumber,
    NotificationList,
  },
  data() {
    return {
      innerWidth: null,
      notifications: {},
      openModalPhoneCall: false
    };
  },
  computed: {
    $currentUser() {
      return this.$store.getters["user/currentUser"];
    }
  },
  mounted() {
    // console.log(this.$currentUID, "my_channel_" + this.$currentUID);
    // console.log("my_channel_" + this.$currentUID);
    // this.$pnSubscribe({
    //   channels: [
    //     "globalChannel",
    //     "my_channel_notification_" + this.$currentUID,
    //     "income_calls_channel_" + this.$currentUID
    //   ]
    // });
    // this.notifications = {
    //   global: this.$pnGetMessage("globalChannel"),
    //   myChannel: this.$pnGetMessage("my_channel_notification_" + this.$currentUID),
    //   incomeCalls: this.$pnGetMessage(
    //     "income_calls_channel_" + this.$currentUID
    //   )
    // };
    this.innerWidth = window.innerWidth;
  },
  methods: {
    openUserSettings() {
      this.$store.dispatch('user/setUserSettings', {...this.$userSettings, openModal: true});
    },
    callToNumber(e) {
      e.preventDefault();
      this.openModalPhoneCall = true;
    },
    onNavToggle() {
      this.$utils.toggleSidebar();
    },
    logout() {
      Auth.logout().then(() => {
        this.$router.replace("/login");
      });
    },
    search(e) {
      if (this.searchByMenu) {
        this.searchByMenu(e.target.value);
      }
    }
  }
};
</script>

<style scoped>
@media (max-width: 576px) {
  .search_panel {
    left: 150px !important;
  }
}

.manager_name {
  font-size: 12px;
  padding: 11px;
}

.icon-fa-phone-square {
  width: 36px;
  height: 36px;
  font-size: 36px;
}

.action-list {
  margin-top: -1px;
  padding-left: 5px;
}

.login-data p {
  margin: 0;
  font-size: 10px;
}

.search_panel {
  width: 210px;
  top: 10px;
  position: absolute;
  left: 240px;
}

.nav-toggle {
  margin-left: 0;
  margin-right: 3px;
}

.fs-22 {
  font-size: 22px;
}

.brand-main img {
  height: 36px;
  padding-top: 0px;
}
</style>
